export var BuilderType;
(function (BuilderType) {
    BuilderType["LicensedBuilder"] = "LICENSED_BUILDER";
    BuilderType["OwnerBuilder"] = "OWNER_BUILDER";
})(BuilderType || (BuilderType = {}));
//# sourceMappingURL=BuilderType.js.map